/**
 * CustomerDisplayStatusBadge — Connection status indicator
 */
import React from 'react';

export default function CustomerDisplayStatusBadge({ connected, terminalId }) {
  return (
    <div className="cfd-status-badge" data-testid="connection-badge">
      <div className={`cfd-status-dot ${connected ? 'live' : 'offline'}`} />
      <span className={connected ? 'cfd-status-live' : 'cfd-status-offline'}>
        {connected ? 'Live' : 'Reconnecting...'}
      </span>
      <span className="cfd-status-sep">|</span>
      <span className="cfd-status-tid">{terminalId}</span>
    </div>
  );
}
